import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Router } from '@angular/router';
import { Lavorazione } from '../../models/lavorazione';
import { Statolavorazione } from '../../models/statolavorazione';
import { Commessa } from '../../models/commessa';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { configurazione } from '../../../configurazioni/configurazione';

@Component({
  selector: 'app-addlavorazione',
  templateUrl: './addlavorazione.component.html',
  styleUrls: ['./addlavorazione.component.css']
})
export class AddlavorazioneComponent implements OnInit {
  selectedValueStato:string;
  lavorazione: Lavorazione;
  commessa: Commessa=new Commessa();
  hide = true;
  stato: Statolavorazione;
  stati: Statolavorazione[];

  rc:number;
  registerForm: FormGroup;
  submitted = false;
  public message =  sessionStorage.getItem('token');

  constructor(private httpClient: HttpClient, private commonService: CommonService,
    private router: Router, private formBuilder: FormBuilder) {

    }

  ngOnInit(): void {


    if (this.registerForm===undefined){
    this.registerForm = this.formBuilder.group({
        selectedValueStato:['', Validators.required],
        Codice:[0],
        Nome:['',Validators.required],
        Nomestato:[''],
        Codicecommessa:[0],
        Codicestatolavorazione:[0]
        });
    }

//    this.commonService.getAllAziende().subscribe((res1) => {
//      console.log("getAllAziende");
//      this.aziende = res1;
//      this.commonService.getAllTipilavorazione().subscribe((res2) => {
//          this.tipilavorazione = res2;
        if (this.commonService.selectedCommessa!=undefined){
          this.commessa=this.commonService.selectedCommessa;
        }

        this.commonService.getAllStatilavorazioni().subscribe((res) => {
            this.stati = res;


            if (this.commonService.selectedLavorazione!=undefined){
                this.lavorazione=this.commonService.selectedLavorazione;
                this.commonService.selectedLavorazione=undefined;

                if (this.stati.length>0){
                  this.stato=this.stati[0];
                  this.stati.forEach(element => {
                    if (this.lavorazione.Statolavorazione.Codice === element.Codice){
                      this.stato=element;
                      this.registerForm.value.selectedValueStato=this.stato.Nome;
                    }
                  });
                }else{
                  this.stato=new Statolavorazione();
                }

                this.registerForm.setValue({
                    selectedValueStato:this.stato.Nome,
                    Codice:this.lavorazione.Codice,
                    Nome:this.lavorazione.Nome,
                    Nomestato:this.lavorazione.Statolavorazione.Nome,
                    Codicecommessa:this.commessa.Codice,
                    Codicestatolavorazione:this.lavorazione.Statolavorazione.Codice,
                  });


            }else{
                this.lavorazione=new Lavorazione();
            }
            this.lavorazione.Commessa=this.commessa;
            this.lavorazione.Codicecommessa=this.commessa.Codice;
        });

  }

aggiornaForm(){

        this.registerForm.setValue({
            selectedValueStato:this.stato.Nome,
            Codice:this.lavorazione.Codice,
            Nome:this.lavorazione.Nome,
            Nomestato:this.lavorazione.Statolavorazione.Nome,
            Codicecommessa: this.lavorazione.Commessa.Codice,
            Codicestatolavorazione: this.lavorazione.Statolavorazione.Codice
          });
}

manageChangeStato(){
  if (this.registerForm.value.selectedValueStato===undefined){
   return;
  }
  this.stati.forEach(element => {
    if (this.registerForm.value.selectedValueStato === element.Nome){
      this.stato=element;
      this.lavorazione.Statolavorazione=this.stato;
    }
  });
  this.aggiornaForm();
}

get f() { return this.registerForm.controls; }

save() {

        this.submitted = true;

        // stop here if form is invalid
        if (this.registerForm.invalid) {
            alert("Errore: verifica i campi indicati con *");
            return;
        }else{


            this.commonService.saveLavorazione(this.registerForm.value).subscribe(data => {
              this.rc=Number(data); //ritorna l'id dell'utente se è stato creato con successo
              //console.log("--->SaveUser"+this.rc.toString());
              if (this.rc===0){
                alert("Lavorazione già esistente");
              }else if (this.rc===-1){
                alert("Errore creazione lavorazione");
              }else {
                alert("Lavorazione salvata con successo");
                this.router.navigate(['lavorazioni']);
              }
            });

        }
    //    alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value))
    }

  cancel(){
    this.commonService.selectedLavorazione=null;
    this.router.navigate(['lavorazioni']);
  }






  myFilter(d: Date): boolean {
  //		const selectinableday = d.getDay();
  //console.log("---->"+d);
    if(d!=undefined){
      const selectinablemonth = d.getMonth();
      const selectinableyear = d.getFullYear();
      const selectinableday = d.getDate();
      const todaysDateObject = new Date();
      const actualday = todaysDateObject.getDate();
      const actualmonth = todaysDateObject.getMonth();
      const actualyear = todaysDateObject.getFullYear();
      if (actualyear - 11> selectinableyear){
        return true;
      }else{
        return false;
      }
    }
    return false;
  }
  getConfigurazione(){
    return configurazione.addlavorazione;
  }
}
